module.exports = __webpack_public_path__ + "img/img10.953460bc.png";